import { Builder } from '@builder.io/react';
import { OfferingTable } from './OfferingTable';
import { BuilderComponents } from '../../helpers/constants';

Builder.registerComponent(OfferingTable, {
  name: BuilderComponents.OFFERING_TABLE,
  inputs: [],
});
